import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { RedeemMainProps } from './RedeemMain';
import { ExecuteRedemptionResponse } from './useExecuteRedemption.hook';

export enum RedeemStackRoutes {
  Main = 'main',
  Edit = 'edit',
  Confirm = 'confirm',
  Result = 'result'
}

export type RedeemStackParamList = {
  [RedeemStackRoutes.Main]: RedeemMainProps & { goBack?: boolean };
  [RedeemStackRoutes.Edit]: RedeemMainProps;
  [RedeemStackRoutes.Confirm]: RedeemMainProps & { netRedemptionAmount: string; isMax?: boolean };
  [RedeemStackRoutes.Result]: RedeemMainProps & { resultData: ExecuteRedemptionResponse };
};

export type RedeemStackScreenProps<Screen extends keyof RedeemStackParamList> = NativeStackScreenProps<RedeemStackParamList, Screen>;
